import { cn } from "@shared/lib/style";
import { formatDateTime } from "@shared/lib/utils";
import Divider from "@shared/ui/divider";

interface AuthorWithDateProps {
  author: string;
  date: string;
  textColor?: string;
  className?: string;
}

export function AuthorWithDate({
  author,
  date,
  textColor = "black",
  className,
}: AuthorWithDateProps) {
  return (
    <div
      className={cn(
        "text-body-3 whitespace-pre text-black/40",
        "max-sm:text-body-5",
        textColor === "white" && "text-white",
        className,
      )}
    >
      <span>{author}</span>
      <Divider
        className={cn(
          "mx-[8px] inline-block bg-black/40 max-sm:inline-block",
          textColor === "white" && "bg-white/80",
        )}
      />
      <span>{formatDateTime(date)}</span>
    </div>
  );
}
